import React from 'react';
import { MBView } from '@shared/components/MBView';
import { View } from '@shared/components/View';
import { MBText } from '@shared/components/text';
import { isStaticTextComponent } from '../../utils';
import { WorkflowComponentProps } from './WorkflowComponent';
import { WorkflowComponentStyles } from './WorkflowComponentStyles';

export function WorkflowStaticTextComponent(props: WorkflowComponentProps) {
  if (!isStaticTextComponent(props.component)) {
    return null;
  }
  return (
    <MBView centerVertically paddingVertical={1} style={WorkflowComponentStyles.container}>
      <View flex>
        <MBText>{props.component.text}</MBText>
      </View>
    </MBView>
  );
}
